import { render, staticRenderFns } from "./PhoneSelector.vue?vue&type=template&id=093814b4&scoped=true&"
import script from "./PhoneSelector.vue?vue&type=script&lang=js&"
export * from "./PhoneSelector.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSelector.vue?vue&type=style&index=0&id=093814b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093814b4",
  null
  
)

export default component.exports